import { render, staticRenderFns } from "./LabLinkCard.vue?vue&type=template&id=2073582f"
import script from "./LabLinkCard.vue?vue&type=script&lang=js"
export * from "./LabLinkCard.vue?vue&type=script&lang=js"
import style0 from "./LabLinkCard.vue?vue&type=style&index=0&id=2073582f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports